import Cookies from 'js-cookie';

export default {
    methods: {
        getDefaultRegistrationParams() {
            const body = {
                nid: localStorage.getItem('nanoId'),
            }

            let inviteCode = Cookies.get('invite_code');
            if (inviteCode) {
                body['invite_refer'] = inviteCode;
            }

            let refer = Cookies.get('fv_refer');
            if (refer) {
                body['fv_referrer'] = refer;
            }

            let fv_location = Cookies.get('fv_location');
            if (fv_location) {
                body['fv_location'] = fv_location;
            }

            let fv_date = Cookies.get('fv_date');
            if (fv_date) {
                body['fv_date'] = fv_date;
            }

            let ga_cid = Cookies.get('_ga');
            if (ga_cid) {
                body['ga_cid'] = ga_cid;
            }

            let ya_cid = Cookies.get('_ym_uid');
            if (ya_cid) {
                body['ya_cid'] = ya_cid;
            }

            return body;
        }
    }
}
